export const EVENT_BUS_SESSION_PORTFOLIO_CHANGED = 'gd.session.projectCollections:change'